// Provides angular filters for lodash or underscore functions
import _ from 'lodash';

const module = angular.module('wbFilters');

_.functions(_).forEach((name) => {
  return module.filter('_' + name, () => _[name]);
});
